module.exports = __webpack_public_path__ + "static/media/mastercard.8fd4355a.svg";